export const TOKEN_STORAGE_KEY = "token";
export const REFRESH_TOKEN_STORAGE_KEY = "refreshToken";
export const AUTH_METHOD_STORAGE_KEY = "hockeyly_auth_method";
export const TENANT_STORAGE_KEY = "hockeyly_selected_tenant";
